import { getColumnsByNames } from './all-top10-columns-config';

export const top15DetectedThreatsReportConfig = getColumnsByNames([
    { name: 'subtype', header: 'Profile' },
    { name: 'severity', width: '15%' },
    { name: 'threatid', width: '35%' },
    { name: 'count', width: '25%' }
]);